import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Box, Card, CardContent, Grid } from "@mui/material";
import ModalLoading from "../../../../components/Formularios/Modal/ModalLoading";

import { useForm } from "react-hook-form";
import { AgenteInterface } from "../../../../types/AgenteInterface";
import { endpointPrincipal } from "../../../../api/endPoints/endpointPrincipal/endpointPrincipal";
import FormTitulo from "../../../../components/Formularios/Container/FormTitulo";
import FormActions from "../../../../components/Formularios/Buttons/FormActions";
import CustomTextField from "../../../../components/Formularios/Inputs/CustomTextField";
import SelectCodSistema from "../../../../components/Formularios/Inputs/SelectCodSistema";
import SwitchAtivo from "../../../../components/Formularios/Inputs/SwitchAtivo";

interface FormAgenteProps {
  idagente?: string;
  acao?: string;
}

const FormAgente = ({ idagente, acao }: FormAgenteProps) => {
  const { register, handleSubmit, setValue, control } = useForm<AgenteInterface>({
    defaultValues: { situacao: 1 },
  });
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);

  const isVisualizando = acao === "Visualizar";

  const carregarAgentePorId = async () => {
    setLoading(true);
    try {
      const { data } = await endpointPrincipal.get(`agentes/${idagente}`);

      setValue("id_agente", data.id_agente);
      setValue("nome", data.nome);
      setValue("email", data.email);
      setValue("funcao", data.funcao);
      setValue("grupo", data.grupo);
      setValue("avatar", data.avatar);
      setValue("ultimo_acesso", data.ultimo_acesso);
      setValue("situacao", data.situacao ?? 1);
    } catch (error) {
      toast.error("Falha ao carregar dados. Motivo: " + error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (idagente && idagente !== "novo") {
      carregarAgentePorId();
    }
  }, [idagente]);

  const atualizarAgentePorId = async (data: AgenteInterface) => {
    setLoading(true);
    try {
      await endpointPrincipal.put(`agentes/${idagente}`, data);
      toast.success(`Agente atualizado com sucesso`);
      setTimeout(() => navigate(-1), 2000);
    } catch (error) {
      toast.error("Falha ao atualizar agente. Motivo: " + error);
    } finally {
      setLoading(false);
    }
  };

  const incluirAgente = async (data: AgenteInterface) => {
    setLoading(true);
    try {
      await endpointPrincipal.post("agentes", data);
      toast.success(`Agente adicionado com sucesso`);
      setTimeout(() => navigate(-1), 2000);
    } catch (error) {
      toast.error(`Erro ao adicionar agente`);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = (data: AgenteInterface) => {
    if (idagente === "novo") {
      incluirAgente(data);
    } else {
      atualizarAgentePorId(data);
    }
  };

  return (
    <>
      <Card>
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <FormTitulo titulo="Agentes" acao={acao} />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <CustomTextField
                  label="Código Agente"
                  name="id_agente"
                  register={register}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomTextField
                  label="Nome"
                  name="nome"
                  register={register}
                  rules={{ required: true }}
                  disabled={isVisualizando}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <SwitchAtivo name="situacao" control={control} disabled={isVisualizando} />
              </Grid>

              <Grid item xs={12} sm={6}>
                <CustomTextField
                  label="Email"
                  name="email"
                  register={register}
                  rules={{ required: true }}
                  disabled={isVisualizando}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <SelectCodSistema
                  tabela="FUNCOES"
                  label="Função"
                  name="funcao"
                  control={control}
                  disabled={isVisualizando}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <SelectCodSistema
                  tabela="GRUPOS"
                  label="Grupo"
                  name="grupo"
                  control={control}
                  disabled={isVisualizando}
                />
              </Grid>
            </Grid>
          </CardContent>
          <FormActions onVoltar={() => navigate(-1)} visualizar={isVisualizando} />
        </Box>
      </Card>
      <ModalLoading show={loading} label="Carregando dados do agente ..." />
    </>
  );
};

export default FormAgente;
